import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { ITagPollingScheduleData } from "../../services/polling-frequency-data-service/Models";
import PollingFrequencyDataService from "../../services/polling-frequency-data-service/PollingFrequencyDataService";


export type MutationContextType = {
    previous: ITagPollingScheduleData[];
};

export type UseSavePollingFrequencyDataParameters = {
    groupID: number,
} & BaseUseMutationParameters<void, ITagPollingScheduleData[]>;

export function useSavePollingFrequencyData({
    groupID,
    onError,
    onSuccess
}: UseSavePollingFrequencyDataParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, ITagPollingScheduleData[], MutationContextType>(
        (item) => {
            return PollingFrequencyDataService.savePollingFrequencyData(groupID, item);
        },
        {
            onMutate: async (item: ITagPollingScheduleData[]) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                queryClient.refetchQueries({
                    queryKey: [keys.data],
                    active: true,
                    inactive: true
                });

                return {
                    previous: item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            
        }
    );
}
